import { PricingPlanModel } from '../../../models/PricingPlansModels';

export const PricingPlansList: PricingPlanModel[] = [
	{
		id: '1',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '2',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '3',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '4',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '5',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '6',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '7',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '8',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '9',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '10',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '11',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '12',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '13',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '14',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '15',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '16',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '17',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '18',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
	{
		id: '19',
		name: 'Basic',
		petitions: 10,
		price: 100,
	},
];
